<h5>
  <label class="badge badge-secondary">
    <i class="fa fa-industry yoni-color mg-r-5"></i>
    <yo-viewmode
      [libelle]="uniteDeProduction?.libelle | uppercase"
      [siteId]="uniteDeProduction?.site?.id">
    </yo-viewmode>
  </label>
</h5>


<yo-dx-tab-menu
  [items]="tabMenuUpDx"
  [selectedItem]="tabSelectedMenuUpDx"
  width="100%"
  marginBottom="24px"
  (itemClick)="goToTabUdp($event)">
</yo-dx-tab-menu>
<div>
  <router-outlet></router-outlet>
</div>
